export const REQUEST_ACTIONS = 'REQUEST_ACTIONS';
export type REQUEST_ACTIONS = typeof REQUEST_ACTIONS;

export const REQUEST_ACTIONS_SUCCESS = 'REQUEST_ACTIONS_SUCCESS';
export type REQUEST_ACTIONS_SUCCESS = typeof REQUEST_ACTIONS_SUCCESS;

export const REQUEST_MAP_DATA = 'REQUEST_MAP_DATA';
export type REQUEST_MAP_DATA = typeof REQUEST_MAP_DATA;

export const REQUEST_MAP_DATA_SUCCESS = 'REQUEST_MAP_DATA_SUCCESS';
export type REQUEST_MAP_DATA_SUCCESS = typeof REQUEST_MAP_DATA_SUCCESS;

export const REQUEST_MAP_DATA_FAILED = 'REQUEST_MAP_DATA_FAILED';
export type REQUEST_MAP_DATA_FAILED = typeof REQUEST_MAP_DATA_FAILED;

export const REQUEST_DASHBOARD_DATA = 'REQUEST_DASHBOARD_DATA';
export type REQUEST_DASHBOARD_DATA = typeof REQUEST_DASHBOARD_DATA;
